import pricesForSeat from '../../utils/sim/prices_for_seat';
import uniq from 'lodash/uniq';

export default  {
  tryAssigningPriceType () {
    // if there is only one available priceType to pick from
    // put this seat directly to the basket
    // by calling this.priceTypeToUnassignedSeat();
    // We only do this if not password protected or already unlocked.
    const validPrices = pricesForSeat(this.state.unassignedSeat, this.state.prices, this.state.priceTypes);
    if (validPrices.length === 1) {
      const priceType = validPrices[0].priceType;
      if (!priceType.isPasswordProtected || priceType.isUnlocked) {
        return this.priceTypeToUnassignedSeat(priceType.number.toString(), false);
      }
    }
  },

  /**
   * Updates GA per Section, Category and Type
   *
   * Note: Use this in your loop
   *
   * If Ticket stub exists, add given quantity
   * else create new stub with new quantityt
   */
  updateGATicketQuantity (section, category, type, quantity) {
    // skip updating if quantity is 0
    if (!quantity) {
      return;
    }

    if (this.existsGATicket(section.id, category, type)) {
      // do stuff
      var GATicket = this.state.GASeats[section.id][category][type];
      this.setState({
        GASeats: {
          ...this.state.GASeats,
          [section.id]: {
            ...this.state.GASeats[section.id],
            [category]: {
              ...this.state.GASeats[section.id][category],
              [type]: {
                ...GATicket,
                qty: GATicket.qty + quantity
              }
            }
          }
        }
      });
    }
    else {
      this.addGASection({
        section: section,
        priceCategory: category,
        priceType: type,
        qty: quantity
      });
    }

    if (this.existsQuantityInSection(section.id, category, type)) {
      var ticket = this.state.quantityInSections[section.id][category][type];

      this.setState({
        quantityInSections: {
          ...this.state.quantityInSections,
          [section.id]: {
            ...this.state.quantityInSections[section.id],
            [category]: {
              ...this.state.quantityInSections[section.id][category],
              [type]: {
                ...ticket,
                qty: ticket.qty + quantity
              }
            }
          }
        }
      });
    }
    else {
      this.addQuantitySection({
        section: section,
        priceCategory: category,
        priceType: type,
        qty: quantity
      });
    }
  },

  /**
   * Checks if a specific GA ticket already exists in the basket
   * @param sectionId
   * @param category
   * @param type
   * @returns {*}
   */
  existsGATicket (sectionId, category, type) {
    return (
      this.state.GASeats[sectionId] &&
      this.state.GASeats[sectionId][category] &&
      this.state.GASeats[sectionId][category][type]
    );
  },

  /**
   * Checks if a specific GA ticket already exists in the basket
   * @param sectionId
   * @param category
   * @param type
   * @returns {*}
   */
  existsQuantityInSection (sectionId, category, type) {
    return (
      this.state.quantityInSections[sectionId] &&
      this.state.quantityInSections[sectionId][category] &&
      this.state.quantityInSections[sectionId][category][type]
    );
  },

  /**
   * Creates a new GA Ticket
   * @param opts
   */
  addGASection (opts) {
    const section       = opts.section;
    const priceCategory = opts.priceCategory;
    const priceType     = opts.priceType;

    this.setState({
      GASeats: {
        ...this.state.GASeats,
        [section.id]: {
          ...(this.state.GASeats[section.id] || {}),
          [priceCategory]: {
            ...((this.state.GASeats[section.id] && this.state.GASeats[section.id][priceCategory]) || {}),
            [priceType]: this.createStub('GA', opts)
          }
        }
      }
    });
  },

  /**
   * Creates a new GA Ticket
   * @param opts
   */
  addQuantitySection ({ section, priceCategory, priceType, qty }) {
    this.setState({
      quantityInSections: {
        ...this.state.quantityInSections,
        [section.id]: {
          ...(this.state.quantityInSections[section.id] || {}),
          [priceCategory]: {
            ...(this.state.quantityInSections[section.id] && this.state.quantityInSections[section.id][priceCategory]) || {},
            [priceType]: {qty: qty}
          }
        }
      }
    });
  },

  cleanGAObject (sectionId, priceCategory) {
    if (!Object.keys(this.state.GASeats[sectionId][priceCategory]).length) {
      const currentGASeats = {...this.state.GASeats};
      delete currentGASeats[sectionId][priceCategory];
      this.setState({GASeats: currentGASeats});
    }
    if (!Object.keys(this.state.GASeats[sectionId]).length) {
      const currentGASeats = {...this.state.GASeats};
      delete currentGASeats[sectionId];
      this.setState({GASeats: currentGASeats});
    }
  },

  createStub (type, opts) {
    let breakDownCode;

    switch (type) {
      case 'GA':
        breakDownCode = opts.section.code.split('-');
        return {
          level:            this.state.areaNames.levels[breakDownCode[0]] || '',
          sectionName:      this.state.areaNames.sections[breakDownCode[1]] || '',
          section:          opts.section.id,
          priceCategory:    this.state.priceCategories[opts.priceCategory],
          priceCategoryId:  opts.priceCategory,
          price:            this.findPrice(opts.priceCategory, opts.priceType),
          qty:              opts.qty,
          areas:            uniq(opts.section.rows.map(r => r.block)),
          acceptNonAdjacentSeats: !this.state.seatmapOverviewMode
        };
      case 'SEAT':
        breakDownCode = opts.id.split('-');
        return {
          level:          this.state.areaNames.levels[breakDownCode[0]] || '',
          section:        this.state.areaNames.sections[breakDownCode[1]] || '',
          row:            opts.row,
          seat:           opts.seat,
          id:             opts.id,
          priceCategory:  opts.priceCategory,
          priceType:      opts.priceType
        };
      default:
        console.error('ERROR, creating a stub of a wrong type', type, opts);
    }
  },

  resetPasswordProtectedUnlockingErrors () {
    // reseting error state for all password protected price types
    Object.keys(this.state.priceTypes).map(ptId => {
      this.setState({
        priceTypes: {
          ...this.state.priceTypes,
          [ptId]: {
            ...this.state.priceTypes[ptId],
            unlockingErrors: null
          }
        }
      });
    });
  },

  /**
   * Find the price from a combination of PriceType and PriceCategory
   * @param priceCategoryId
   * @param priceTypeId
   * @returns {*}
   */
  findPrice (priceCategoryId, priceTypeId) {
    for (var i = 0, l = this.state.prices.length; i < l; ++i) {
      var price = this.state.prices[i];
      if (price.priceCategory === priceCategoryId && price.priceType === priceTypeId) {
        return price;
      }
    }
  },

  calculateTotal () {
    var that        = this;
    var stubs       = this.state.activeSeats;
    var seatTickets = Object.keys(stubs);
    var changes = {};

    // tot up the single seat stubs
    changes.total = seatTickets.reduce(function (total, seatId) {
      var stub  = stubs[seatId];
      var price = that.findPrice(stub.priceCategory, stub.priceType);
      if (price && price.price) {
        total += price.price;
      }
      return total;
    }, 0);

    changes.count = seatTickets.length;

    // add to the single seats the GA seats
    var GATicketSections = Object.keys(this.state.GASeats);

    GATicketSections.forEach(function (sectionId) {
      var GAPriceCategories  = this.state.GASeats[sectionId];
      var GAPriceCategoryIds = Object.keys(GAPriceCategories);

      GAPriceCategoryIds.forEach(function (priceCategoryId) {
        var GAPriceTypes   = GAPriceCategories[priceCategoryId];
        var GAPriceTypeIds = Object.keys(GAPriceTypes);

        GAPriceTypeIds.forEach(function (priceTypeId) {
          var GA = GAPriceTypes[priceTypeId];

          // sum up the totals
          changes.total += GA.qty * GA.price.price;
          changes.count += GA.qty;
        }, this);
      }, this);
    }, this);

    if (!this.state.count) {
      changes.showTickets = false;
    }

    this.setState(changes);
  }
};



// WEBPACK FOOTER //
// ./frontend/react/stores/basket/basket_helpers.js